export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';
export const REGISTER_SNACKBAR = 'REGISTER_SNACKBAR';
export const DEREGISTER_SNACKBAR = 'DEREGISTER_SNACKBAR';

export const showSnackbar = payload => ({
  type: SHOW_SNACKBAR,
  payload,
});

export const hideSnackbar = () => ({ type: HIDE_SNACKBAR });

export const registerSnackbar = payload => ({
  type: REGISTER_SNACKBAR,
  payload,
});

export const deregisterSnackbar = payload => ({
  type: DEREGISTER_SNACKBAR,
  payload,
});

const initialSnackbarsState = {
  message: null,
  type: null,
  registeredSnackbars: [],
};

export default (state = initialSnackbarsState, action) => {
  switch (action.type) {
    case SHOW_SNACKBAR: {
      const { message, values, type, icon = null, isLowStyle = false, description = null } = action.payload;
      return { ...state, message, values, type, icon, isLowStyle, description };
    }
    case HIDE_SNACKBAR: {
      const { registeredSnackbars } = state;
      return { ...initialSnackbarsState, registeredSnackbars };
    }
    case REGISTER_SNACKBAR: {
      const { id } = action.payload;
      const { registeredSnackbars } = state;
      return { ...state, ...initialSnackbarsState, registeredSnackbars: [id].concat(registeredSnackbars) };
    }
    case DEREGISTER_SNACKBAR: {
      const { id } = action.payload;
      const { registeredSnackbars } = state;
      return {
        ...state,
        ...(id === registeredSnackbars[0] ? initialSnackbarsState : {}),
        registeredSnackbars: registeredSnackbars.filter(snackbarId => snackbarId !== id),
      };
    }
    default:
      return state;
  }
};
